export const removePunctuation = (text) => {
    return text.replace(/[.,/#!$%^&*;:{}=-_`~()]/g, "").replace(/s{2,}/g, " ")
}